import React from 'react'
import { Form, Input } from 'antd'
import type { FlowStep } from '@/data'
import { ButtonsListEditor } from './ButtonsListEditor'

interface QualificationEditorProps {
  step: FlowStep
  onChange: (step: FlowStep) => void
}

export const QualificationEditor: React.FC<QualificationEditorProps> = ({
  step,
  onChange,
}) => {
  const buttons = step.inputs.filter((i) => i.type === 'radio')

  return (
    <Form layout="vertical" size="small">
      <Form.Item label="Headline">
        <Input
          value={step.headline}
          onChange={(e) => onChange({ ...step, headline: e.target.value })}
          placeholder="Enter headline"
        />
      </Form.Item>

      <Form.Item label="Sub Headline">
        <Input
          value={step.sub_headline}
          onChange={(e) => onChange({ ...step, sub_headline: e.target.value })}
          placeholder="Enter sub headline"
        />
      </Form.Item>

      <Form.Item label="Buttons">
        <ButtonsListEditor
          buttons={buttons}
          onChange={(updatedButtons) =>
            onChange({ ...step, inputs: updatedButtons })
          }
        />
      </Form.Item>
    </Form>
  )
}
